module.exports = __webpack_public_path__ + "static/assets/682da989d442750088077c7a699dec0a.gif";